import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';

export class NsBindHtml extends PolymerElement {
    static get is() {
        return 'ns-bind-html';
    }

    static get properties() {
        return {
            html: {
                type: String,
                observer: '_updatedContent'
            }
        }
    }

    constructor() {
        super();
    }

    ready() {
        super.ready();
        this.innerHTML = this.html;
    }

    _updatedContent(newValue, oldValue) {
        this.innerHTML = this.html;
    }
}
customElements.define(NsBindHtml.is, NsBindHtml);
